import { clampTrackGainDb } from '@/shared/track-gain.ts'

/** Track `volume` is gain in dB (−24…+3). */
export const trackVolumeToGain = (volume: number): number =>
  clampTrackGainDb(volume)
